import { type JSX } from "react";
import { cn } from "../../lib/utils";
import { TooltipCell } from "../table/TooltipCell";
import { IconMaterial } from "../shared/iconMaterial/IconMaterial";

type BodyTableProps = {
  id?: string | null;
  rows: any[];
};

export const BodyTableInfo = ({
  rows,
}: BodyTableProps): JSX.Element => {

  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );

  return (
    <>
      {rows.map((order, index) => {
        return (
          <tr key={index} >
            <td
              className={cn(
                baseCellClassName,
                "relative overflow-hidden",
              )}
            >
              <TooltipCell
                content={order.medicine_name}
              />
              <div className="rounded-l-lg flex items-center group h-full w-full">
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block"
                  size={16}
                  iconColor="var(--tokens-text-secondary-text)" />
              </div>
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell
                content={order?.category}
              />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.dosage} />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.dosage_unit} />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.amount} />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.unit} />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.concentration} />
            </td>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.density} />
            </td>
          </tr>
        );
      })}
    </>
  );
};
